const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { PORTFOLIO_SAVED_VIEW_BASE } from '@/features/views/hooks/useViewSurfacePaths';
import { redirectToLoopVisualizationOfType } from '@/features/visualizations/utils/redirectToLoopVisualizationOfType';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/')({
  loader: async ({
    params,
    context: {
      queryClient
    }
  }) => {
    await redirectToLoopVisualizationOfType({
      org: params.org,
      loopId: params.loopId,
      viewId: params.viewId,
      queryClient,
      savedViewBase: PORTFOLIO_SAVED_VIEW_BASE
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});